import MainNavigationLink from 'components/links/MainNavigationLink';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DesktopNavigationDropdownLink: FunctionComponent<Props> = ({
    className = '',
    link,
    testId = TEST_ID,
    text
}) => (
    <MainNavigationLink
        className={`${styles.dropdownNavigationLink} ${className}`}
        link={link}
        testId={testId}
        text={text}
    />
);

export default DesktopNavigationDropdownLink;
